const images = {
    energy: require('./icon-flash.png'),
    publicPlace: require('./icon-place-public.png'),
    privatePlace: require('./icon-place-home.png'),
    timerIcon: require('./icon-timer.png'),
};
export default images;
